import React from 'react';
import Grid from '@mui/material/Grid2';
import { Box } from "@mui/material";

const MuiBox = ({ children, greyBox = false, ...props }) => {

	if (greyBox) {
		props.sx = {
			backgroundColor: "grey.100",
			border: "1px solid grey",
			borderRadius: "8px",
			padding: 2,
			marginTop: 1,
			marginBottom: 2,
			width: "100%",
			...props.sx
		};
	}

  return (
    <Box {...props}>
      {children}
    </Box>
  );
};

export default MuiBox;